<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <!-- Camera overlay for web/PWA barcode scanning — always in DOM, hidden when not scanning -->
  <app-camera-overlay></app-camera-overlay>
</ion-app>
